module.exports = __webpack_public_path__ + "static/img/5.0112b35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/eng/5.png
// module id = GnQS
// module chunks = 0